import { PriceViewModel } from 'src/common/models';
import { RatePlanFragment } from 'src/common/__generated__/api/types';
import { ThemeName } from 'constants/theme';

import { adaptFeeMessagesForRatePlan } from './fee-messages-adapter';

import RatePlan = RatePlanFragment.Fragment;

export const adaptPrice = (ratePlan: RatePlan): PriceViewModel => {
  if (!ratePlan) {
    return null;
  }

  const price = ratePlan.priceDetails?.[0]?.price;

  return {
    pointsApplied: adaptPointsApplied(ratePlan.priceDetails),
    feeMessages: adaptFeeMessagesForRatePlan(ratePlan),
    lead: price?.lead?.formatted,
    numberOfNightsAndRooms: price?.roomNightMessage,
    strikeOutType: price?.strikeOutType,
    strikeOut: price?.strikeOut?.formatted,
    strikeoutDisclaimer: price?.disclaimer?.value,
    priceMessaging: price?.priceMessaging,
    marketingFeeDetails: adaptMarketingFeeDetails(ratePlan),
    options: price?.options,
    priceMessage: adaptPriceMessage(ratePlan.priceDetails?.[0]?.availability),
  };
};

export const adaptMarketingFeeDetails = ratePlan => {
  const marketingFeeDetails = ratePlan?.priceDetails?.[0]?.price?.marketingFeeDetails;

  if (!marketingFeeDetails) {
    return null;
  }

  return {
    tierIcon: marketingFeeDetails?.tierIcon,
    tierName: marketingFeeDetails?.tierName,
    marketingFeeMessage: marketingFeeDetails?.marketingFeeMessage.value,
  };
};

export const adaptPointsApplied = priceDetails => {
  const filteredDetails = priceDetails?.filter(priceDetail => priceDetail.pointsApplied);

  return filteredDetails?.[0]?.pointsApplied;
};

export const adaptPriceMessage = availability => {
  if (availability?.text) {
    return {
      text: availability.text,
      theme: ThemeName[availability.theme],
    };
  }

  return null;
};
